// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsAuthenticationGetCurrentUserGetCurrentUserContactInfoResponseModel {
    static getAttributeTypeMap() {
        return ScriptsAuthenticationGetCurrentUserGetCurrentUserContactInfoResponseModel.attributeTypeMap;
    }
}
ScriptsAuthenticationGetCurrentUserGetCurrentUserContactInfoResponseModel.discriminator = undefined;
ScriptsAuthenticationGetCurrentUserGetCurrentUserContactInfoResponseModel.attributeTypeMap = [
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
    {
        "name": "isPreferred",
        "baseName": "isPreferred",
        "type": "boolean"
    }
];
//# sourceMappingURL=scriptsAuthenticationGetCurrentUserGetCurrentUserContactInfoResponseModel.js.map